/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener
 * crm-screener
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ExternalEhrDocument } from './ExternalEhrDocument';
import {
    ExternalEhrDocumentFromJSON,
    ExternalEhrDocumentFromJSONTyped,
    ExternalEhrDocumentToJSON,
    ExternalEhrDocumentToJSONTyped,
} from './ExternalEhrDocument';
import type { ScreenerGeneratedDocumentType } from './ScreenerGeneratedDocumentType';
import {
    ScreenerGeneratedDocumentTypeFromJSON,
    ScreenerGeneratedDocumentTypeFromJSONTyped,
    ScreenerGeneratedDocumentTypeToJSON,
    ScreenerGeneratedDocumentTypeToJSONTyped,
} from './ScreenerGeneratedDocumentType';
import type { ScreenerGeneratedDocumentStatus } from './ScreenerGeneratedDocumentStatus';
import {
    ScreenerGeneratedDocumentStatusFromJSON,
    ScreenerGeneratedDocumentStatusFromJSONTyped,
    ScreenerGeneratedDocumentStatusToJSON,
    ScreenerGeneratedDocumentStatusToJSONTyped,
} from './ScreenerGeneratedDocumentStatus';

/**
 * 
 * @export
 * @interface ScreenerGeneratedDocument
 */
export interface ScreenerGeneratedDocument {
    /**
     * 
     */
    id?: string;
    /**
     * 
     */
    lead_id?: string;
    /**
     * 
     */
    name?: string;
    /**
     * Null while the document is pending or generating asynchronously.
     */
    s3_key?: string;
    /**
     * Null while the document is pending or generating asynchronously.
     */
    generated_at?: string;
    /**
     * 
     */
    instance_id?: string;
    /**
     * 
     */
    previous_generated_at?: string;
    /**
     * 
     */
    type?: ScreenerGeneratedDocumentType;
    /**
     * 
     */
    status?: ScreenerGeneratedDocumentStatus;
    /**
     * True when this document is stale enough that regenerating it would fetch fresh data instead of re-serving the cached copy.
     */
    can_regenerate?: boolean;
    /**
     * 
     */
    external_ehr_document?: ExternalEhrDocument;
}



/**
 * Check if a given object implements the ScreenerGeneratedDocument interface.
 */
export function instanceOfScreenerGeneratedDocument(value: object): value is ScreenerGeneratedDocument {
    return true;
}

export function ScreenerGeneratedDocumentFromJSON(json: any): ScreenerGeneratedDocument {
    return ScreenerGeneratedDocumentFromJSONTyped(json, false);
}

export function ScreenerGeneratedDocumentFromJSONTyped(json: any, ignoreDiscriminator: boolean): ScreenerGeneratedDocument {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'lead_id': json['lead_id'] == null ? undefined : json['lead_id'],
        'name': json['name'] == null ? undefined : json['name'],
        's3_key': json['s3_key'] == null ? undefined : json['s3_key'],
        'generated_at': json['generated_at'] == null ? undefined : json['generated_at'],
        'instance_id': json['instance_id'] == null ? undefined : json['instance_id'],
        'previous_generated_at': json['previous_generated_at'] == null ? undefined : json['previous_generated_at'],
        'type': json['type'] == null ? undefined : ScreenerGeneratedDocumentTypeFromJSON(json['type']),
        'status': json['status'] == null ? undefined : ScreenerGeneratedDocumentStatusFromJSON(json['status']),
        'can_regenerate': json['can_regenerate'] == null ? undefined : json['can_regenerate'],
        'external_ehr_document': json['external_ehr_document'] == null ? undefined : ExternalEhrDocumentFromJSON(json['external_ehr_document']),
    };
}

export function ScreenerGeneratedDocumentToJSON(json: any): ScreenerGeneratedDocument {
    return ScreenerGeneratedDocumentToJSONTyped(json, false);
}

export function ScreenerGeneratedDocumentToJSONTyped(value?: ScreenerGeneratedDocument | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'lead_id': value['lead_id'],
        'name': value['name'],
        's3_key': value['s3_key'],
        'generated_at': value['generated_at'],
        'instance_id': value['instance_id'],
        'previous_generated_at': value['previous_generated_at'],
        'type': ScreenerGeneratedDocumentTypeToJSON(value['type']),
        'status': ScreenerGeneratedDocumentStatusToJSON(value['status']),
        'can_regenerate': value['can_regenerate'],
        'external_ehr_document': ExternalEhrDocumentToJSON(value['external_ehr_document']),
    };
}

